// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Salut {{first_name}}, de quoi avez-vous besoin pour {{restaurant}} ?',
  title_no_name: 'Bonjour, de quoi avez-vous besoin pour {{restaurant}} ?',
  text: 'Je peux répondre à vos questions sur {{restaurant}} et effectuer des modifications pour vous. Rien ne change sans votre accord.',
  suggestions: 'Suggestions',
  prompts: {
    reports: {
      top_dishes: 'Quels ont été les 10 plats les plus vendus le mois dernier ?',
      sales_vs_last_month: 'Comment les ventes ont-elles évolué par rapport au mois dernier ?',
    },
    menu: {
      raise_dish_price: 'Augmenter le prix de {{dish}} de {{amount}}',
      dish_sold_out: 'Marquer {{dish}} comme épuisé',
      dishes_without_photo: "Quels plats n'ont pas de photo ?",
    },
    hours: {
      holiday_hours: "Modifier nos horaires d'ouverture du 24 décembre",
    },
    order_settings: {
      minimum_order: 'Augmenter la commande minimum à {{amount}}',
    },
    marketing: {
      promo_code: 'Créer un code promo de 10 % pour ce week-end',
    },
    my_info: {
      phone_number: 'Mettre à jour notre numéro de téléphone',
    },
  },
};
